import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import Column from '../../layout/Column/index';
import withStyles, { createStyles } from '../withStyles';
const styles = (theme) => createStyles({
    root: {
        flexShrink: 0,
        padding: theme.spacing(2),
    },
    noPaddingBottom: {
        paddingBottom: 0,
    },
});
export const FormSection = ({ children, classes, paddingBottom = true, }) => (_jsx(Column, Object.assign({ className: cn(classes.root, !paddingBottom && classes.noPaddingBottom) }, { children: children })));
export default withStyles(styles)(FormSection);
//# sourceMappingURL=FormSection.js.map